export default "__VITE_ASSET__DTI2nepC__"